import { load } from 'poly-eshop4/eshop/ui/js/util';

$(document).on('click', '[data-request-user-delete]', function() {
  $.ajax({
    method: 'GET',
    url: $(this).attr('data-request-user-delete'),
  }).done((response) => {
    $(response).appendTo($('body')).foundation().foundation('open');
  });
});

$(document).on('submit', '[data-request-user-delete-form]', function(event) {
  event.preventDefault();
  const $form = $(this);
  const $reveal = $form.closest('[data-reveal]');
  load(
    $reveal,
    $.ajax({
      url: $form.attr('action'),
      data: $form.serialize(),
      method: 'post',
    }),
  ).done((response) => {
    if (!response) {
      setTimeout(() => $reveal.foundation('close'), 1500);
    } else {
      $reveal.foundation('close');
    }
  });
});

$(window).on('load', () => {
  const $contactCards = $('[data-agent-block]');
  $contactCards.each(function () {
    const $this = $(this);
    $.ajax({
      url: $this.data('agent-block'),
      method: 'GET',
      success: (resp) => {
        $this.replaceWith(resp);
      },
      error: () => {
        $this.closest('.widget').remove();
      },
    });
  });
});
